import { call, cancelled, put, takeLatest } from "redux-saga/effects";
import { DOCUMENT_CENTER } from "./actionTypes";
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { DOCUMENT_CENTER_URL } from "../../helpers/url_api_helper";
import { getDocumentCenterProducts, getDownloadDocumentCenter, getListaDocumentCenter } from "./actions";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";

function* getListaDocumentCenterSaga({ payload }) {
    const controller = new AbortController();
    try {
        emptyStringToNull(payload);
        const res = yield call(DOCUMENT_CENTER_URL.getDocumentCenterLista, payload, {
            signal: controller.signal,
        });
        yield put(getListaDocumentCenter.success(res));
    } catch (error) {
        yield put(getListaDocumentCenter.fail(
            normalizeApiError(
                error,
                "Something went wrong retrieving the document center list, please try again later",
            )
        ));
    } finally {
        if(yield cancelled()) {
            controller.abort();
        }
    }
}

function* obterDocumentCenterProducts({ payload }) {
    const { documentId } = payload;

    try {
        const res = yield call(DOCUMENT_CENTER_URL.getDocumentCenterProduct, documentId);
        yield put(getDocumentCenterProducts.success(res));
    } catch (error) {
        yield put(getDocumentCenterProducts.fail(
            normalizeApiError(
                error,
                "Something went wrong retrieving the document center products, please try again later",
            )
        ));
    }
}

function* obterDownloadDocumentCenter({ payload }) {
    const { documentId, type } = payload;

    try {
        const res = yield call(DOCUMENT_CENTER_URL.getDocumentCenterDownload, documentId, type);
        res.extension = type;
        yield put(getDownloadDocumentCenter.success(res));
    } catch (error) {
        yield put(getDownloadDocumentCenter.fail(
            normalizeApiError(
                error,
                "Something went wrong retrieving the document center download, please try again later",
            )
        ));
    }
}

function* documentCenterSaga() {
    yield takeLatest(DOCUMENT_CENTER.GET_LIST.REQUEST, getListaDocumentCenterSaga);
    yield takeLatest(DOCUMENT_CENTER.GET_DOCUMENT_CENTER_PRODUCTS.REQUEST, obterDocumentCenterProducts);
    yield takeLatest(DOCUMENT_CENTER.GET_DOWNLOAD_DOCUMENT_CENTER.REQUEST, obterDownloadDocumentCenter);
}

export default documentCenterSaga;